export function filterQuestsForExternalReviewer(quests) {
  return quests.filter(function (quest) {
    return quest.visible_for_external_review
  })
}

export function getQuestFilterQuery(filterState, orgId, user) {
  let query = {}

  query.organization_id_eq = orgId

  if (filterState.reviewing_compiled_quest_state_null) {
    query.reviewing_compiled_quest_state_null =
      filterState.reviewing_compiled_quest_state_null
  }

  if (filterState.authors_id_in && filterState.authors_id_in.length > 0) {
    query.authors_id_in = filterState.authors_id_in
  }

  if (filterState.questtags_id_in && filterState.questtags_id_in.length > 0) {
    query.questtags_id_in = filterState.questtags_id_in
  }

  if (
    filterState.reviewing_compiled_quest_state_in &&
    filterState.reviewing_compiled_quest_state_in.length > 0
  ) {
    query.reviewing_compiled_quest_state_in =
      filterState.reviewing_compiled_quest_state_in
  }

  if (
    filterState.name_or_description_cont &&
    filterState.name_or_description_cont.trim() !== ''
  ) {
    query.name_or_description_cont = filterState.name_or_description_cont
  }

  if (
    user.organization_roles &&
    user.organization_roles.indexOf('qm_external_review') > -1
  ) {
    query.visible_for_external_review_true = true
  }

  if (
    filterState.quest_subject_id_in &&
    filterState.quest_subject_id_in.length > 0
  ) {
    query.quest_subject_id_in = filterState.quest_subject_id_in
  }

  if (
    filterState.assigned_to_id_in &&
    filterState.assigned_to_id_in.length > 0
  ) {
    query.assigned_to_id_in = filterState.assigned_to_id_in
  }

  if (
    filterState.grade_levels_id_in &&
    filterState.grade_levels_id_in.length > 0
  ) {
    query.grade_levels_id_in = filterState.grade_levels_id_in
  }

  if (filterState.state_in && filterState.state_in.length > 0) {
    query.state_in = filterState.state_in
  }

  // storing object in redux, sending array of one id to BE
  if (filterState.mock_course_id_in) {
    query.mock_course_id_in = [filterState.mock_course_id_in.id]
  }

  if (filterState.mock_level_id_in && filterState.mock_level_id_in.length > 0) {
    query.mock_level_id_in = filterState.mock_level_id_in
  }

  if (filterState.need_final_review) {
    query.need_final_review = filterState.need_final_review
  }

  if (filterState.need_standards_review) {
    query.need_standards_review = filterState.need_standards_review
  }

  if (
    filterState.reviewTrackingStatus &&
    filterState.reviewTrackingStatus !== null
  ) {
    query.in_internal_review =
      filterState.reviewTrackingStatus.in_internal_review
    query.in_copy_edit = filterState.reviewTrackingStatus.in_copy_edit
  }

  if (
    filterState.reviewTrackingStatus &&
    filterState.reviewTrackingStatus === null
  ) {
    query.in_internal_review = false
    query.in_copy_edit = false
  }

  return query
}

export const questsSearchFiltersAreDirty = filtersState =>
  !!(
    (filtersState.assignedToFilters &&
      filtersState.assignedToFilters.length > 0) ||
    (filtersState.authorFilters && filtersState.authorFilters.length > 0) ||
    (filtersState.courseFilter &&
      Object.keys(filtersState.courseFilter).length > 0) ||
    (filtersState.hasOwnProperty('allStatusChecked') &&
      !filtersState.allStatusChecked) ||
    (filtersState.gradeFilters && filtersState.gradeFilters.length > 0) ||
    (filtersState.keywordFilter && filtersState.keywordFilter.length > 0) ||
    (filtersState.levelFilters && filtersState.levelFilters.length > 0) ||
    (filtersState.primarySubjectFilters &&
      filtersState.primarySubjectFilters.length > 0) ||
    (filtersState.reviewTrackingStatus &&
      Object.keys(filtersState.reviewTrackingStatus).length > 0) ||
    (filtersState.statusFilters && filtersState.statusFilters.length > 0) ||
    (filtersState.tagFilters && filtersState.tagFilters.length > 0)
  )



// WEBPACK FOOTER //
// ./src/utils/quests.js